import { createAction, ActionType } from 'typesafe-actions'

export const flagsToggleFlaggedAction = createAction('TOGGLE_FLAGGED')<{
  engagementId: number
  questionId: number
}>()

export type FlagActions = ActionType<typeof flagsToggleFlaggedAction>
